import { createRoot } from 'react-dom/client';
import App from './App';

// Self-hosted via @fontsource (bundled by Vite, same-origin — no CDN).
// Workhorse UI: IBM Plex Sans 400/500/600. Wordmark: Syne 600. Numerics: IBM Plex Mono 400/500.
import '@fontsource/ibm-plex-sans/400.css';
import '@fontsource/ibm-plex-sans/500.css';
import '@fontsource/ibm-plex-sans/600.css';
import '@fontsource/syne/600.css';
import '@fontsource/ibm-plex-mono/400.css';
import '@fontsource/ibm-plex-mono/500.css';

import './index.css';

// A deploy replaces the content-hashed chunks, so a tab opened before it
// requests assets that no longer exist the first time it visits a lazy
// route. Vite surfaces that as a preload error; one reload picks up the new
// index and chunk names instead of stranding the tab on the error boundary.
// The timestamp guard means a genuinely broken chunk (not a stale one)
// degrades back to the error boundary rather than a reload loop.
window.addEventListener('vite:preloadError', (event) => {
  const RELOADED_AT = 'chunk-reload-at';
  const last = Number(sessionStorage.getItem(RELOADED_AT) ?? '0');
  if (Date.now() - last < 60_000) return;
  sessionStorage.setItem(RELOADED_AT, String(Date.now()));
  event.preventDefault();
  window.location.reload();
});

createRoot(document.getElementById('root')!).render(<App />);
